import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-gradient-to-r from-electric-cyan/20 to-cosmic-purple/20 text-electric-cyan hover:from-electric-cyan/30 hover:to-cosmic-purple/30 border-electric-cyan/30",
        secondary:
          "border-transparent bg-gray-800 text-gray-300 hover:bg-gray-700",
        destructive:
          "border-transparent bg-red-500 text-red-50 shadow hover:bg-red-500/80",
        outline: "text-gray-300 border-gray-600 hover:bg-gray-800",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }